<template>
  <div class='tg-e3-swiper'>
    <div class="tg-e3-swiper_container swiper-container-one">
      <div class="swiper-wrapper">
        <div class="swiper-slide"
             v-for='item in itemsSource'
             :key='item.id'>
          <tg-flexbox>
            <tg-uniform-scale :ratio="`${9 / 16 * 100}%`">
              <a :href="item.locationlink == null ? '/' + channel + '/news/' + item.id : item.locationlink">
                <img :src="item.pic | imgURL('600_')"
                     :style="{position: 'relative', width: '100%', height: '100%', objectFit: 'cover'}"
                     alt="item.title">
              </a>
            </tg-uniform-scale>
          </tg-flexbox>
          <h3>
            <p class='tg-e3-swiper_title'>{{item.title}}</p>
          </h3>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
export default {
  name: 'tg-swiper_container',
  props: {
    itemsSource: {
      type: Array,
      require: true,
    },
    channel: {
      type: String,
      require: false,
      default() {
        return 'e3';
      },
    },
  },
  mounted() {
    /* eslint-disable */
    const mySwiper = new Swiper('.swiper-container-one', {
      loop: true,
      autoplay: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'tg-e3-swiper_bullets',
        bulletActiveClass: 'tg-e3-swiper_bullets-active',
      },
    });
  },
};
</script>
